import React from "react";
import ReactDOM from "react-dom/client";
import store, { persistor } from "./Store/AppContext";
import App from "./App";
import "./Resources/Lib/Normalize/normalize.css";
import "./Resources/Sass/main.scss";
import "./Resources/Css/site.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "core-js/stable";
import "react-dates/initialize";
import * as serviceWorker from "./serviceWorker";

const { PUBLIC_URL } = process.env;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App
    store={store}
    persistor={persistor}
    basename={PUBLIC_URL}
  />
);

serviceWorker.unregister();
